import { useEffect, useState, useContext } from 'react';
import { Query } from '../../../utils/query';
import { Order } from '../../../utils/table';
import { SearchSortContext } from '../../../context/SearchSortContext';
import {
  ChangeSearchPayload,
  PageSearchSortContextActionType,
} from '../../../context/types';
import parseUrlFilterSearch from '../../../hooks/parseUrlFilterSearch';
import useUrlFilterSearch from '../../../hooks/useUrlFilterSearch';
import { UrlParam } from '../../../redux/types/filter';
import { Device } from '../../../redux/types/devices';

const useDevices = (
  loadDevices: (query: Query & { builderId: number }) => void,
  builderId: number,
) => {
  const urlParse = parseUrlFilterSearch<UrlParam>();
  const {
    dispatch,
    state: { devices },
  } = useContext(SearchSortContext);
  const {
    currentOrderBy,
    currentOrder,
    currentPage,
    rowsPerPageAmount,
    contextSearch,
  } = devices;

  const [search, setSearch] = useState<string>(
    urlParse.search || contextSearch,
  );
  const [order, setOrder] = useState<Order>(urlParse.order || currentOrder);
  const [orderBy, setOrderBy] = useState<keyof Device>(
    urlParse.orderBy || currentOrderBy,
  );
  const [page, setPage] = useState<number>(urlParse.page || currentPage);
  const [rowsPerPage, setRowsPerPage] = useState<number>(
    urlParse.limit || rowsPerPageAmount,
  );

  useUrlFilterSearch<UrlParam>({
    search,
    order,
    orderBy,
    page: String(page),
    limit: rowsPerPage,
  });

  const dispatchDevices = (
    type: PageSearchSortContextActionType<'CHANGE_DEVICE'>,
    payload?: ChangeSearchPayload<Device>,
  ) => dispatch({ type, payload: { ...devices, ...payload } });

  useEffect(() => {
    loadDevices({
      search,
      order,
      orderBy,
      page: String(page),
      limit: rowsPerPage,
      builderId,
    });
  }, [
    order,
    orderBy,
    page,
    rowsPerPage,
    search,
    loadDevices,
    builderId,
  ]);

  return {
    order,
    orderBy,
    page,
    search,
    rowsPerPage,
    setSearch,
    setOrder,
    setOrderBy,
    setPage,
    setRowsPerPage,
    dispatchDevices,
  };
};

export default useDevices;
